import React from 'react';
import './HomePage.css';
import homeimage from '../../Images/home-image.svg';
import totalproduct from '../../Images/totalproduct.svg';
import projectcomplete from '../../Images/Projectcompleted.svg';
import totalcustomer from '../../Images/totalcustomer.svg';
import yearsofexp from '../../Images/yrsofexp.svg';
import customerimage1 from '../../Images/customer-image-1.svg';
import customerimage2 from '../../Images/customer-image-2.svg';
import customerimage3 from '../../Images/customer-image-3.svg';
import customerimage4 from '../../Images/customer-image-4.svg';
import customerimage5 from '../../Images/customer-image-5.svg';
import { customers, products, projects, yearsOfExperience } from '../companyDetails';
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
    const navigate = useNavigate();

    return (
        <>
            <section className='home-page-container' id='home'>
                <div className='home-page-content'>
                    <div className='home-title-container'>
                        <h1 className='home-title'>Your One-Stop Solution for Quality Products.</h1>
                    </div>
                    <p className='home-subtitle'>We are a diversified global trading company delivering high-standard medical equipment, power solutions, and cargo shipping services.
                        Driven by a commitment to excellence, innovation, and operational integrity, we provide integrated solutions that empower the healthcare, energy, and logistics sectors.Our approach is built on strong governance, professional service, and long-term partnerships founded on trust and performance. </p>
                    <div className='home-actions'>
                        <button className='explore-btn' onClick={() => navigate('/products')}>Explore <span className='right-arrow'>➔</span></button>
                        {/* <div className='profile-section'>
                            <img src={customerimage1} alt="User 1" className='user-images' />
                            <img src={customerimage2} alt="User 2" className='user-images' />
                            <img src={customerimage3} alt="User 3" className='user-images' />
                            <img src={customerimage4} alt="User 4" className='user-images' />
                            <img src={customerimage5} alt="User 5" className='user-images' />
                        </div> */}
                    </div>
                    {/* <div className='status-grid'>
                        <div className='status-card'>
                            <img src={totalcustomer} alt='totalcustomer' className='status-card-image' />
                            <p className='status-card-text'>Total Customer<span className='updating-home-values'>+{customers.length}</span></p>
                        </div>
                        <div className='status-card'>
                            <img src={totalproduct} alt='totalproduct' className='status-card-image' />
                            <p className='status-card-text'>Total Product's<span className='updating-home-values'>+{products.length}</span></p>
                        </div>
                        <div className='status-card'>
                            <img src={yearsofexp} alt='years-of-experience' className='status-card-image' />
                            <p className='status-card-text'>Years of Experience<span className='updating-home-values'>+{yearsOfExperience}</span></p>
                        </div>
                        <div className='status-card'>
                            <img src={projectcomplete} alt='projects-completed' className='status-card-image' />
                            <p className='status-card-text'>Projects Completed<span className='updating-home-values'>+{projects.length}</span></p>
                        </div>
                    </div> */}
                    <img src={homeimage} alt='home-image' className='home-image' />
                </div>
            </section>
        </>
    )
}

export default HomePage;